import { BoardTimeline } from '../../model/board-timeline';
/**
 *
 * @param timeline
 * @returns The length of the transition timeline.
 */
export function getLengthOfTimeline(timeline: BoardTimeline): number {
  return timeline ? timeline.boardEndYear - timeline.scenarioStartYear + 1 : 0;
}
